import HomeUser from './HomeUser';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import Store from '../Store';

const store = new Store('userManagement');
export const CURRENT_USER_KEY = 'current-user';

export const updated$ = new ReplaySubject<HomeUser>(1);

export function update(user: HomeUser) {
  set(user);
  updated$.next(user);
}

export function get(): HomeUser {
  return HomeUser.deserialize(store.get(CURRENT_USER_KEY) || '');
}

function set(user: HomeUser) {
  store.set(CURRENT_USER_KEY, user.serialize());
}

export function remove(): void {
  store.remove(CURRENT_USER_KEY);
}



// WEBPACK FOOTER //
// ./packages/platform-core/identity/crud.ts